export default __webpack_public_path__ + "static/media/24.51df07c9.png";